import React from 'react';
import { NavLink } from 'react-router-dom'
import './NavLinks.css';

const NavLinks: React.FC = () => {
    return (
        <ul className="nav-links">
            <li>
                <NavLink to="/">Home</NavLink>
            </li>
            <li>
                <NavLink to="/play">Play</NavLink>
            </li>
            <li>
                <NavLink to="/about">About</NavLink>
            </li>
        </ul>
    );
}

export default NavLinks;